import React from 'react';
export function FocusSection() {
  return <section className="w-full bg-white py-16 md:py-24 px-6" data-id="element-106">
      <div className="max-w-3xl mx-auto text-center" data-id="element-107">
        <div className="font-serif italic text-2xl md:text-4xl text-charcoal-500 leading-loose space-y-5" data-id="element-108">
          <p data-id="element-109">La maternidad no es solo aprender qué hacer.</p>
          <p data-id="element-110">También es aprender a escuchar… a observar… a conectar</p>
          <p data-id="element-111">Con tu bebé y con vos misma.</p>
          <p className="text-warm-500 mt-8" data-id="element-112">
            Tu bebé no viene con un manual.
            <br data-id="element-113" />
            Pero eso no significa que tengas que hacerlo sola.
          </p>
        </div>
      </div>
    </section>;
}